export { default } from "./ErrorBoundaryFallback";
